let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kUyEy")).then(() => parcelRequire('d5iyz'));